export default {
    response: 'RESPONSE_VIEW',
    searchResult: 'SEARCH_RESULT_VIEW',
    searchedMessageConversation: 'SEARCH_MESSAGE_CONVERSATION_VIEW'
}